// extracted by css-extract-rspack-plugin
export default {"value":"playback-rate-option-module__value___DXWtY"};